import * as React from 'react';
import styled from 'styled-components';

import { SEO } from '@/components/global/SEO';
import { AnchorProvider } from '@/components/home-2025/Context';
import { DataApps } from '@/components/home-2025/DataApps';
import { Hero } from '@/components/home-2025/Hero';
import { Notebooks } from '@/components/home-2025/notebooks/Notebooks';
import { SelfServe } from '@/components/home-2025/SelfServe';
import { StickyNav } from '@/components/home-2025/StickyNav';
import { Workflows } from '@/components/home-2025/Workflows';
import Page from '@/components/v2/Page';
import { LayoutSubgrid } from '@/components/v2/Page/LayoutGrid';
import { V1PageWrapper } from '@/components/v2/Page/V1PageWrapper';
import { SOCIAL_SHARE } from '@/utils/social-share-images';
import { BottomCTATout } from '@components/home/BottomCTATout';

import { IntegrationsTout } from '../components/global/IntegrationsTout';
import { BuildAnythingTout } from '../components/home/BuildAnythingTout';
import { CustomerStoriesTout } from '../components/home/CustomerStoriesTout';
import { SecurityTout } from '../components/home/SecurityTout';

const Wrapper = styled.div`
  width: 100%;
`;

const RefreshPage: React.ComponentType = React.memo(() => {
  return (
    <Page
      seo={
        <SEO
          description="Hex is the AI-powered analytics workspace built for teams driving faster answers and better decisions."
          image={SOCIAL_SHARE.HomePage}
          title="Go deeper than dashboards"
          url="/"
        />
      }>
      <AnchorProvider>
        <Hero />
        {/* <CustomerBanner /> */}
        <Workflows />
        <LayoutSubgrid style={{ position: 'relative' }}>
          <StickyNav />
          <Notebooks />
          <DataApps />
          <SelfServe />
        </LayoutSubgrid>
        <V1PageWrapper noTopPadding>
          <Wrapper>
            {/* <ProductOverviewTout /> */}
            <CustomerStoriesTout />
            <IntegrationsTout />
            <SecurityTout />
            <BuildAnythingTout />
            <BottomCTATout />
          </Wrapper>
        </V1PageWrapper>
      </AnchorProvider>
    </Page>
  );
});

export default RefreshPage;
